import { VIDEO_FULLSCREEN_ACTIVE, VIDEO_FULLSCREEN_INACTIVE } from './types';

export const videoFullScreenActive = () => ({
  type: VIDEO_FULLSCREEN_ACTIVE
});

export const videoFullScreenInactive = () => ({
  type: VIDEO_FULLSCREEN_INACTIVE
});
